import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dashDisplay' })
export class DashDisplayPipe implements PipeTransform {
  transform(str: string | number, text = '-') {
    str = (str || str === 0) && str.toString();
    return str ? str : text;
  }
}
